<template>
  <div class="equipment-maintenance d-flex">
    <div class="left-cont">
      <div
        v-for="(tab, index) in leftCont"
        :key="index"
        :class="['tab-cont', currentTab == index && 'current-bg']"
        @click="handlerToggleTab(index)"
      >
        <div class="tab-icon">
          <img :src="imgList[tab.displayName][tab.icon]" alt="" />
        </div>
        <div class="tab-name">{{ tab.displayName }}</div>
      </div>
    </div>
    <div class="right-cont">
      <Mainten
        v-if="currentTab == 0"
        :equipmentList="equipmentList"
        :itemsList="itemsList"
      ></Mainten>
      <Repair
        v-else
        :equipmentList="equipmentList"
        :itemsList="itemsList"
      ></Repair>
    </div>
  </div>
</template>

<script>
import Mainten from "./Mainten.vue";
import Repair from "./Repair.vue";
export default {
  data() {
    return {
      currentTab: 0,
      imgList: {
        设备保养: {
          choosed: require("@/assets/images/设备保养选中.png"),
          unChoose: require("@/assets/images/设备保养.png"),
        },
        设备维修: {
          choosed: require("@/assets/images/设备维护选中.png"),
          unChoose: require("@/assets/images/设备维护.png"),
        },
      },
      leftCont: [
        {
          icon: "choosed",
          displayName: "设备保养",
        },
        {
          icon: "unChoose",
          displayName: "设备维修",
        },
      ],
    };
  },
  props: {
    equipmentList: {
      type: Array,
      default: () => [],
    },
    itemsList: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    handlerToggleTab(index) {
      this.currentTab = index;
      this.leftCont.forEach((cont, i) => {
        if (index == i) {
          cont.icon = "choosed";
        } else {
          cont.icon = "unChoose";
        }
      });
    },
  },
  components: {
    Mainten,
    Repair,
  },
};
</script>

<style scoped lang='scss'>
.equipment-maintenance {
  .left-cont {
    margin-right: 30px;
    width: 150px;
    .tab-cont {
      background: #e9ebec;
      border-radius: 4px;
      padding: 20px 0;
      margin-bottom: 30px;
      display: flex;
      flex-flow: column;
      align-items: center;
      color: #495057;
      font-size: 14px;
      .tab-icon {
        margin-bottom: 10px;
      }
      &:nth-last-of-type(1) {
        margin-bottom: 0;
      }
      &.current-bg {
        background: url("../../assets/images/选中框.png") no-repeat;
        background-size: 100% 100%;
        color: #fff;
        width: 160px;
        padding-right: 10px;
      }
    }
  }
  .right-cont {
    flex: 1;
  }
}
</style>
